export default "__VITE_PUBLIC_ASSET__4c4b284b__"